import { PaymentTypeService } from '../../../shared/services/paymenttype/paymenttype.service';
import { ButtonRendererComponent } from '../../../renderer/button-renderer.component';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { debounceTime, tap, switchMap, finalize } from 'rxjs/operators';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-paymenttype-list',
  templateUrl: './paymenttype-list.component.html',
  styleUrls: ['./paymenttype-list.component.css']
})
export class PaymentTypeListComponent implements OnInit, OnDestroy {
  paymenttypeIsAuthenticated = false;
  private authStatusSub: Subscription;
  frameworkComponents: any;
  // Id for polling
  timeoutId: any;

  //for Grid
  rowData: any;
  columnDefs = [];
  localeText: any;

  filters;
  getRowHeight: (params: any) => number;
  constructor(public router: Router, private authService: AuthService, public paymenttypeService: PaymentTypeService, public translate: TranslateService) {
    this.frameworkComponents = {
      buttonRenderer: ButtonRendererComponent
    }
    this.filters = { name: "", fName: "", cnic: "", status: "", city: "" };
    this.getRowHeight = function (params) {
      return 50;
    };
  }

  ngOnInit() {
    this.paymenttypeIsAuthenticated = this.authService.getIsAuth();
    this.authStatusSub = this.authService.getAuthStatusListener().subscribe(isAuthenticated => {
      this.paymenttypeIsAuthenticated = isAuthenticated;
    });
    this.paymenttypeService.getPaymentTypeListData(sessionStorage.getItem("userId")).subscribe(data => {
      this.rowData = data.paymenttype;
    });
    this.translate.get('PaymentTypeListScreen').subscribe((response: any) => {
      this.initializeColumnDef(response);
    });
    this.translate.onLangChange.subscribe((event) => {
      this.translate.get('PaymentTypeListScreen').subscribe((response: any) => {
        this.initializeColumnDef(response);
      });
    });

  }

  initializeColumnDef(response: any) {
    this.columnDefs = [
      { headerName: response.Column3,  field: 'name', sortable: true, filter: true, cellStyle: { textAlign: "left" } },
      {
        headerName: response.Column4,
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          onClick: this.GridEditButton.bind(this),
          label: response.Column4,
          type:"Edit"
        }, cellStyle: { textAlign: "left" }
      },
      {
        headerName: response.Column5,
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          onClick: this.GridDeleteButton.bind(this),
          label: response.Column5,
          type:"Delete"
        }, cellStyle: { textAlign: "left" }
      }
    ];
    this.localeText = { noRowsToShow: response.noRowsToShow, loadingOoo: response.loading };
  }

  GridEditButton(gridData) {
    this.router.navigate(['/addPaymentType'], { queryParams: { Id: gridData.rowData._id } });
  }

  GridDeleteButton(gridData) {
    this.paymenttypeService.deletePaymentTypeById(gridData.rowData._id).subscribe(data => {
      this.paymenttypeService.getPaymentTypeListData(sessionStorage.getItem("userId")).subscribe(response => {
        this.rowData = response.paymenttype;
      });
    });
  }

  ngOnDestroy() {
    this.authStatusSub.unsubscribe();
    clearInterval(this.timeoutId);
    this.rowData = [];
  }

  newPaymentType() {
    this.router.navigate(['/addPaymentType']);
  }

}
